import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'shared/utils/axiosBaseQuery'

const economyApi = createApi({
  reducerPath: 'economy',
  baseQuery: axiosBaseQuery({ baseUrl: '' }),
  endpoints: () => ({}),
})

export default economyApi
